import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { Subscription } from 'rxjs';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { BusinessProcessService } from '../../../../services/business-process.service';
import { Utils } from '../../../../services/utils';
import { ElementLock } from '../../../../Models/elementLock';
import { DesignElementType } from '../../../../Models/enum/designElementType';
import { HumanInteractionTokenResult } from '../../../../Models/humanInteractionTokenResult';
import { GenericModalService } from '../../../../services/generic-modal.service';
import { GenericInputModalComponent } from '../../../../generic-modal/generic-input-modal/generic-input-modal.component';
import { CustomValidator } from '../../../../services/custom-validator';


@Component({
  selector: 'app-state-detail',
  templateUrl: './state-detail.component.html',
  styleUrls: ['./state-detail.component.css', '../../../../styles/business-process-configuration.css']
})
export class StateDetailComponent implements OnInit {

  @ViewChild('stateTabs', { static: false }) stateTabs: TabsetComponent;
  @ViewChildren('nextStatesCheckboxes') nextStatesCheckboxes: QueryList<ElementRef>;
  stateForm: FormGroup;
  isNew: boolean;
  errorMessage = '';
  flowStateError = '';
  flowPageError = '';
  pageLayoutError = '';
  successMessage = '';
  pleaseWait = false;
  inscription: Subscription;
  utilsFunction = Utils;
  elementLock: ElementLock = null;
  lockingUserLogon: string;
  isLockedToOtherUser = false;
  isLockedToMe = false;
  stateId: number;
  bpId: number;
  stateInfo: any[];
  availableFlows: any[];
  availableStates: any[];
  availableLayouts: any[];
  availablePageFlows: any[];
  stateColumns = [];
  selectedNextStates = [];
  alertBackgroundColor = '#000';
  alertFontColor = '#ffffff';
  alertStart;
  stateFlowDesignerUrl;
  pageFlowDesignerUrl;
  debuggerUrl;
  destComponent: any = GenericInputModalComponent;

  get formData() { return this.stateForm.controls; }

  constructor(
    private formBuilder: FormBuilder,
    private bpService: BusinessProcessService,
    private route: ActivatedRoute,
    private router: Router,
    private modalService: GenericModalService
  ) { }

  ngOnInit() {
    this.isNew = this.router.url.includes('/newState');
    this.createForm();
    this.inscription = this.route.params.subscribe(params => {
      this.bpId = params['businessProcessId'];
      if (!isNaN(parseFloat(this.bpId.toString()))) {
        this.pleaseWait = true;
        if (this.isNew) {
          this.isLockedToMe = true;
          this.stateInfo = [];
          this.loadSelectFields();
          this.pleaseWait = false;
        } else {
          this.stateId = params['stateId'];
          if (!isNaN(parseFloat(this.stateId.toString()))) {
            this.getStateForManagementById();
          } else {
            this.pleaseWait = false;
            this.errorMessage = 'O parâmetro informado não é válido.';
          }
        }
      } else {
        this.errorMessage = 'O parâmetro informado não é válido.';
      }
    });
  }

  getStateForManagementById() {
    this.errorMessage = '';
    this.bpService.getStateForManagementById(this.bpId, this.stateId).subscribe(result => {
      if (result) {
        this.stateInfo = result;
        this.getCurrentElementLock();
        this.loadStateData();
        this.loadSelectFields();
        if (this.stateInfo['stateFlowId']) { this.generateStateFlowDesignerURL(this.stateInfo['stateFlowId']); }
        if (this.stateInfo['pageFlowId']) { this.generatePageFlowDesignerURL(this.stateInfo['pageFlowId']); }
        this.generateDebuggerURL();
        this.pleaseWait = false;
      } else {
        this.pleaseWait = false;
        this.errorMessage = 'Estado não encontrado.';
      }
    }, error1 => {
      this.pleaseWait = false;
      this.errorMessage = error1;
    });
  }

  loadSelectFields() {
    this.loadStateFlows();
    this.loadStates();
    this.loadPageLayouts();
    this.loadPageFlows();
  }

  createForm() {
    this.stateForm = this.formBuilder.group({
      captionTextTemplate: [''],
      creationDate: [formatDate(Date.now(), 'yyyy-MM-dd', 'en_US')],
      description: ['',  Validators.maxLength(300)],
      detailsTextTemplate: [''],
      displayName: ['',  Validators.maxLength(100)],
      executionTimeout: [null],
      flow: [''],
      hasContinuousHumanInteraction: [false],
      hasContinuousInteractionAlert: [false],
      hasTimer: [false],
      humanInteractionEngine: [2],
      interactionTimeout: [0],
      interactionTimeoutAlertBackgroundColor: ['#000'],
      interactionTimeoutAlertFontColor: ['#fff'],
      interactionTimeoutAlertStart: [null],
      interactionTimeoutStateId: [null],
      isInitial: [false],
      isTimerFloating: [false],
      isTimerVisible: [false],
      isValid: [false],
      maxAttachments: [null, [Validators.min(0), Validators.max(2147482), CustomValidator.numericButNotRequired]],
      maxSizePerAttachment: [null, [Validators.min(0), Validators.max(100), CustomValidator.numericButNotRequired]],
      modifiedBy: [null],
      name: ['', [ Validators.required, Validators.maxLength(100) ]],
      nextHumanInteractionTimeOut: [null],
      nextStates: [ ],
      nextStateIds: [ ],
      pageFlow: [''],
      pageFlowId: [null],
      pageLayout: [null],
      pageLayoutId: [null],
      pageLayoutName: [''],
      preDefinedOverrideStateId: [null],
      stateFlowId: [null],
      stateId: [0],
      timerDirection: [1],
      userInteractionTimeout: [0],
      validationDescription: [null],
      version: [0]
    });
    this.updateAlertStart(0);
  }

  loadStateData() {
    if (this.stateInfo['executionTimeout']) {
      this.stateInfo['executionTimeout'] = this.stateInfo['executionTimeout'] / 1000;
    }

    if (this.stateInfo['interactionTimeoutAlertStart']) {
      this.stateInfo['interactionTimeoutAlertStart'] = this.stateInfo['interactionTimeoutAlertStart'] / 1000;
    }

    if (this.stateInfo['nextHumanInteractionTimeOut']) {
      this.stateInfo['nextHumanInteractionTimeOut'] = this.stateInfo['nextHumanInteractionTimeOut'] / 1000;
    }

    if (this.stateInfo['userInteractionTimeout']) {
      this.stateInfo['userInteractionTimeout'] = this.stateInfo['userInteractionTimeout'] / 1000;
    }

    if (this.stateInfo['interactionTimeout']) {
      this.stateInfo['interactionTimeout'] = this.stateInfo['interactionTimeout'] / 1000;
    }

    if (this.stateInfo['interactionTimeoutAlertBackgroundColor']) {
      this.alertBackgroundColor = this.stateInfo['interactionTimeoutAlertBackgroundColor'];
    }

    if (this.stateInfo['interactionTimeoutAlertFontColor']) {
      this.alertFontColor = this.stateInfo['interactionTimeoutAlertFontColor'];
    }

    this.updateAlertStart(this.stateInfo['interactionTimeoutAlertStart']);
    this.selectedNextStates = this.stateInfo['nextStateIds'];

    this.stateForm.patchValue({
      captionTextTemplate: this.stateInfo['captionTextTemplate'],
      creationDate: this.stateInfo['creationDate'],
      description: this.stateInfo['description'],
      detailsTextTemplate: this.stateInfo['detailsTextTemplate'],
      displayName: this.stateInfo['displayName'],
      executionTimeout: this.stateInfo['executionTimeout'],
      hasContinuousHumanInteraction: this.stateInfo['hasContinuousHumanInteraction'],
      hasContinuousInteractionAlert: this.stateInfo['hasContinuousInteractionAlert'],
      hasTimer: this.stateInfo['hasTimer'],
      humanInteractionEngine: this.stateInfo['humanInteractionEngine'],
      interactionTimeout: this.stateInfo['interactionTimeout'],
      interactionTimeoutAlertBackgroundColor: this.stateInfo['interactionTimeoutAlertBackgroundColor'],
      interactionTimeoutAlertFontColor: this.stateInfo['interactionTimeoutAlertFontColor'],
      interactionTimeoutAlertStart: this.stateInfo['interactionTimeoutAlertStart'],
      interactionTimeoutStateId: this.stateInfo['interactionTimeoutStateId'],
      isInitial: this.stateInfo['isInitial'],
      isTimerFloating: this.stateInfo['isTimerFloating'],
      isTimerVisible: this.stateInfo['isTimerVisible'],
      isValid: this.stateInfo['isValid'],
      maxAttachments: this.stateInfo['maxAttachments'],
      maxSizePerAttachment: this.stateInfo['maxSizePerAttachment'],
      modifiedBy: this.stateInfo['modifiedBy'],
      name: this.stateInfo['name'],
      nextHumanInteractionTimeOut: this.stateInfo['nextHumanInteractionTimeOut'],
      nextStateIds: this.stateInfo['nextStateIds'],
      pageFlowId: this.stateInfo['pageFlowId'],
      pageLayoutId: this.stateInfo['pageLayoutId'],
      preDefinedOverrideStateId: this.stateInfo['preDefinedOverrideStateId'],
      stateFlowId: this.stateInfo['stateFlowId'],
      stateId: Number(this.stateId),
      timerDirection: this.stateInfo['timerDirection'],
      userInteractionTimeout: this.stateInfo['userInteractionTimeout'],
      version: this.stateInfo['version']
    });
    this.setValidationsWhenHasTimer(this.stateInfo['hasTimer'], this.stateInfo['isTimerVisible'], this.stateInfo['timerDirection']);
    this.setVisibleTimerValidators(this.stateInfo['isTimerVisible'], this.stateInfo['timerDirection'], this.stateInfo['hasTimer']);
    this.setTimerDirectionValidators(this.stateInfo['timerDirection'], this.stateInfo['isTimerVisible'], this.stateInfo['hasTimer']);
    if (!this.isLockedToMe) { this.stateForm.disable(); }
  }

  loadStateFlows() {
    this.errorMessage = '';
    this.bpService.getLibraryByType(this.bpId, 1, 2).subscribe(result => {
      if (result) {
        this.availableFlows = result;
      }
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  loadPageLayouts() {
    this.errorMessage = '';
    this.bpService.getLibraryByType(this.bpId, 2, 0).subscribe(result => {
      if (result) {
        this.availableLayouts = result;
      }
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  loadPageFlows() {
    this.errorMessage = '';
    this.bpService.getLibraryByType(this.bpId, 1, 3).subscribe(result => {
      if (result) {
        this.availablePageFlows = result;
      }
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  loadStates() {
    this.errorMessage = '';
    this.bpService.getStatesByBusinessProcessId(this.bpId).subscribe(result => {
      if (result) {
        this.availableStates = result;

        this.stateColumns = [];

        const numberOfItemsPerColumn = Math.ceil(this.availableStates.length / 2);

        for (let i = 0; i !== this.availableStates.length; i++) {
          const column = Math.floor(i / numberOfItemsPerColumn);
          if (!this.stateColumns[column]) {
            this.stateColumns[column] = [];
          }

          this.checkNextState(this.availableStates[i]);

          this.stateColumns[column].push(this.availableStates[i]);
        }
      }
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  checkNextState(availableState) {
    if (!this.stateInfo['nextStateIds']) { return; }
    const nxtSt = this.stateInfo['nextStateIds'].filter(id => id === availableState.stateId);
    if (nxtSt && nxtSt.length === 1) {
      availableState.isNextState = true;
    }
  }

  onEdit() {
    this.errorMessage = '';
    if (!this.isLockedToOtherUser) {
      this.stateForm.enable();
      this.bpService.beginEditingElement(DesignElementType.State, Number(this.stateId), this.stateInfo['name'])
        .subscribe( () => { this.getCurrentElementLock(); }, error1 => { this.errorMessage = error1; });
    }
  }

  onUnlock() {
    this.errorMessage = '';
    this.bpService.endEditingElement(DesignElementType.State, Number(this.stateId), this.stateInfo['name'])
      .subscribe( () => {
        this.successMessage = 'Estado desbloqueado';
        setTimeout(() => {  this.successMessage = ''; this.getCurrentElementLock(); }, 1700);
      }, error1 => this.errorMessage = error1);
  }

  onSave() {
    this.errorMessage = '';
    this.pleaseWait = true;
    const newStateInfo = this.stateForm.getRawValue();

    const stateFlowSelection = <HTMLSelectElement>document.getElementById('stateFlow');
    newStateInfo.flow = stateFlowSelection.selectedOptions[0] ? stateFlowSelection.selectedOptions[0].dataset.name : '';
    const pageFlowSelection = <HTMLSelectElement>document.getElementById('pageFlowId');
    newStateInfo.pageFlow = pageFlowSelection.selectedOptions[0] ? pageFlowSelection.selectedOptions[0].dataset.name : '';
    const pageLayoutSelection = <HTMLSelectElement>document.getElementById('pageLayout');
    newStateInfo.pageLayoutName = pageLayoutSelection.selectedOptions[0] ?
      pageLayoutSelection.selectedOptions[0].dataset.name : '';
    newStateInfo.displayName = newStateInfo.displayName.trim();

    if (this.stateForm.controls.timerDirection.value === 1) {
      newStateInfo.userInteractionTimeout = 0;
    }

    if (!this.stateForm.controls.maxAttachments.value || this.stateForm.controls.maxAttachments.value === 0) {
      newStateInfo.maxAttachments = 0;
      newStateInfo.maxSizePerAttachment = 0;
    }

    if (newStateInfo.executionTimeout === '') { newStateInfo.executionTimeout = null; }

    newStateInfo.interactionTimeoutAlertBackgroundColor = this.alertBackgroundColor;
    newStateInfo.interactionTimeoutAlertFontColor = this.alertFontColor;

    newStateInfo.nextStateIds = this.selectedNextStates;

    if (this.isNew) {
      this.createBusinessProcess(newStateInfo);
    } else {
      this.updateBusinessProcessState(newStateInfo);
    }
  }

  createBusinessProcess(newStateInfo: any) {
    this.bpService.createBusinessProcessState(this.bpId, newStateInfo).subscribe(
      newStateId => {
        this.successMessage = 'Estado salvo com sucesso';
        this.pleaseWait = false;
        setTimeout(() => {  this.successMessage = ''; this.router.navigate(['/state', this.bpId, newStateId]); }, 1700);
      }, error1 => {
        this.pleaseWait = false;
        this.errorMessage = error1;
      }
    );
  }

  updateBusinessProcessState(newStateInfo: any) {
    this.bpService.updateBusinessProcessState(this.bpId, newStateInfo).subscribe(
      () => {
        this.pleaseWait = false;
        this.successMessage = 'Estado alterado com sucesso';
        this.getStateForManagementById();
        setTimeout(() => {  this.successMessage = ''; this.onUnlock(); }, 1700);
      }, error1 => {
        this.pleaseWait = false;
        this.errorMessage = error1;
      }
    );
  }

  updateAlertStart(param: number) {
    if (param) {
      this.alertStart = new Date(param * 1000).toISOString().substr(11, 8);
    }
  }

  clearSelectedValue(control: AbstractControl) {
    control.setValue(null);
    control.updateValueAndValidity();
    if (this.getName(control) === 'stateFlowId') {
      this.setStateFlowValidators(control.value);
    }
    if (this.getName(control) === 'pageLayoutId') {
      if (control.value === 0 || control.value === null) {
        this.stateForm.patchValue({
          captionTextTemplate: null,
          detailsTextTemplate: null
        });
      }
    }
  }

  addStateFlow() {
    this.flowStateError = '';
    const result$ = this.modalService.showInputModal(
      this.destComponent,
      'Novo fluxo de estado',
      'Insira o nome do novo fluxo de estado',
      'OK', 'Cancelar',
      'FluxoEstado' + this.stateForm.controls['name'].value,
      '^[a-zA-Z][a-zA-Z0-9_]+',
      'Um nome válido deve ter entre 1 e 100 caracteres, deve ser iniciado por letra e deve ser composto somente por letras, números e underscore.',
      100, 1, true
    );
    result$.asObservable()
      .pipe()
      .subscribe(
        result => {
          if (result !== null) {
            this.bpService.createStateLibraryFlow(result, Number(this.bpId), 'stateFlow')
              .subscribe( newFlowId => {
                  this.loadStateFlows();
                  this.stateForm.patchValue( {
                    stateFlowId: newFlowId
                  });
                },
                error1 => {
                  this.stateForm.controls.stateFlowId.reset();
                  this.flowStateError = error1;
                });
          }
        }
      );
  }

  addPageLayout() {
    this.pageLayoutError = '';
    const result$ = this.modalService.showInputModal(
      this.destComponent,
      'Novo layout de tela',
      'Insira o nome do novo layout de tela',
      'OK', 'Cancelar',
      'LayoutEstado' + this.stateForm.controls['name'].value,
      '^[a-zA-Z][a-zA-Z0-9_]+',
      'Um nome válido deve ter entre 1 e 100 caracteres, deve ser iniciado por letra e deve ser composto somente por letras, números e underscore.',
      100, 1, true
    );
    result$.asObservable()
      .pipe()
      .subscribe(
        result => {
          if (result !== null) {
            this.bpService.createStateLibraryLayout(result, Number(this.bpId))
              .subscribe( newPageLayoutId => {
                  this.loadPageLayouts();
                  this.stateForm.patchValue( {
                    pageLayoutId: newPageLayoutId
                  });
                },
                error1 => {
                  this.stateForm.controls.pageLayoutId.reset();
                  this.pageLayoutError = error1;
                });
          }
        }
      );
  }

  addPageFlow() {
    this.flowPageError = '';
    const result$ = this.modalService.showInputModal(
      this.destComponent,
      'Novo fluxo de tela',
      'Insira o nome do novo fluxo de tela',
      'OK', 'Cancelar',
      'FluxoPagina' + this.stateForm.controls['name'].value,
      '^[a-zA-Z][a-zA-Z0-9_]+',
      'Um nome válido deve ter entre 1 e 100 caracteres, deve ser iniciado por letra e deve ser composto somente por letras, números e underscore.',
      100, 1, true
    );
    result$.asObservable()
      .pipe()
      .subscribe(
        result => {
          if (result !== null) {
            this.bpService.createStateLibraryFlow(result, Number(this.bpId), 'pageFlow')
              .subscribe(newFlowId => {
                  this.loadPageFlows();
                  this.stateForm.patchValue({
                    pageFlowId: newFlowId
                  });
                },
                error1 => {
                  this.stateForm.controls.pageFlowId.reset();
                  this.flowPageError = error1;
                });
          }
        }
      );
  }

  onBack() {
    if (this.isLockedToMe) {
      this.onUnlock();
    }
    this.router.navigate(['/businessProcess', this.bpId]);
  }

  getSelectedNextStates(value) {
    if (value.checked) {
      this.selectedNextStates.push(Number(value.id.match(/[-]?[0-9]+/g)[0]));
    } else {
      this.selectedNextStates.splice(this.selectedNextStates.indexOf(Number(value.id.match(/[-]?[0-9]+/g)[0])), 1);
    }
  }

  getCurrentElementLock() {
    this.errorMessage = '';
    const userLogon = localStorage.getItem('userLogon').toLowerCase();
    this.bpService.getCurrentElementLock(DesignElementType.State, Number(this.stateId))
      .subscribe( element => {
        this.elementLock = element;
        if (element) {
          this.lockingUserLogon = element.user.logon;
          this.isLockedToOtherUser = this.lockingUserLogon && this.lockingUserLogon.toLowerCase() !== userLogon;
          this.isLockedToMe = this.bpId === 0 ? true : !this.isLockedToOtherUser;
          this.isLockedToOtherUser ? this.stateForm.disable() : this.stateForm.enable();
        } else {
          this.stateForm.disable();
          this.isLockedToOtherUser = false;
          this.isLockedToMe = false;
        }
      }, error1 => this.errorMessage = error1);
  }

  openStateLayoutEditor() {
    this.bpService.getTokenForLayoutEditor()
      .subscribe((resp: HumanInteractionTokenResult) => {
        if (resp) {
          // const layoutId = this.stateInfo['pageLayoutId'];
          const layoutId = this.stateForm.controls.pageLayoutId.value;
          // const bpId = this.bpId;
          const options = `{ "BusinessProcessId": ${this.bpId}, "LibraryItemId": ${layoutId} }`;
          window.open(resp.humanInteractionBaseUrl + '/LayoutEditorV2/Default.aspx?Token=' +
            resp.humanInteractionToken + '&LoginHandle=' + resp.loginHandle + '&data=' + options, '_blank');
        }
      }, error1 => this.errorMessage = error1);
  }

  generateStateFlowDesignerURL(stateFlowId) {
    this.flowStateError = '';
    // console.log(stateFlowId.selectedOptions[0].dataset.name);
    this.stateFlowDesignerUrl = undefined;
    if (!stateFlowId) { return; }
    this.setStateFlowValidators(stateFlowId);
    this.bpService.generateFlowDesignerURL(Number(this.bpId), stateFlowId, 1)
      .subscribe((resp: any) => {
        if (resp) {
          this.stateFlowDesignerUrl = resp.url;
        }
      }, error1 => this.flowStateError = error1);
  }

  generatePageFlowDesignerURL(pageFlowId: number) {
    this.flowPageError = '';
    this.pageFlowDesignerUrl = undefined;
    if (!pageFlowId) { return; }
    this.bpService.generateFlowDesignerURL(this.bpId, pageFlowId, 2)
      .subscribe((resp: any) => {
        if (resp) {
          this.pageFlowDesignerUrl = resp.url;
        }
      }, error1 => this.flowPageError = error1 );
  }

  generateDebuggerURL() {
    this.errorMessage = '';
    this.debuggerUrl = undefined;
    this.bpService.generateDebuggerURL(this.bpId, this.stateId, 1)
      .subscribe((resp: any) => {
        if (resp) {
          this.debuggerUrl = resp.url;
        }
      }, error1 => this.errorMessage = error1);
  }

  openStateFlow() {
    if (!this.stateFlowDesignerUrl) { return; }
    window.open(this.stateFlowDesignerUrl, '_parent');
  }

  openPageFlow() {
    if (!this.pageFlowDesignerUrl) { return; }
    window.open(this.pageFlowDesignerUrl, '_parent');
  }

  openDebugger() {
    if (!this.debuggerUrl) { return; }
    window.open(this.debuggerUrl, '_parent');
  }

  openFlowDesignerSetup() {
    window.open('./DesignerSetup/Crivo.Workflow.EditorDeFluxos.msi', '_self');
  }

  setValidationsWhenHasTimer(hasTimer, isTimerVisible, timerDirection) {
    if (hasTimer === true) {
      this.stateForm.get('interactionTimeout').setValidators([
        Validators.min(1),
        Validators.max(2147482),
        CustomValidator.numeric
      ]);
      this.stateForm.get('interactionTimeoutStateId').setValidators(Validators.required);
    } else {
      this.stateForm.get('interactionTimeout').clearValidators();
      this.stateForm.get('interactionTimeoutStateId').clearValidators();
      this.stateForm.patchValue({
        interactionTimeout: 0,
        interactionTimeoutStateId: null,
        isTimerVisible: false
      });
    }
    this.stateForm.get('interactionTimeout').updateValueAndValidity();
    this.stateForm.get('interactionTimeoutStateId').updateValueAndValidity();
    this.setVisibleTimerValidators(isTimerVisible, timerDirection, hasTimer);
  }

  setVisibleTimerValidators(isTimerVisible, timerDirection, hasTimer) {
    if (hasTimer === true && isTimerVisible === true) {
      this.stateForm.get('interactionTimeoutAlertStart').setValidators([
        Validators.min(1),
        Validators.max(2147482),
        CustomValidator.numeric
      ]);
    } else {
      this.stateForm.get('interactionTimeoutAlertStart').clearValidators();
      this.stateForm.patchValue({
        interactionTimeoutAlertStart: null,
        timerDirection: 1,
        isTimerFloating: false
      });
    }
    this.stateForm.get('interactionTimeoutAlertStart').updateValueAndValidity();
    this.setTimerDirectionValidators(timerDirection, isTimerVisible, hasTimer);
  }

  setTimerDirectionValidators(timerDirection, isTimerVisible, hasTimer) {
    if (hasTimer === true && timerDirection === 2 && isTimerVisible === true) {
      this.stateForm.get('userInteractionTimeout').setValidators([
        Validators.min(1),
        Validators.max(2147482),
        CustomValidator.numeric
      ]);
    } else {
      this.stateForm.get('userInteractionTimeout').clearValidators();
      this.stateForm.patchValue({
        userInteractionTimeout: 0
      });
    }
    this.stateForm.get('userInteractionTimeout').updateValueAndValidity();
  }

  setStateFlowValidators(stateFlowId) {
    if (stateFlowId !== 0 && stateFlowId !== '' && stateFlowId !== null) {
      this.stateForm.get('executionTimeout').setValidators([
        Validators.min(0),
        Validators.max(2147482),
        CustomValidator.numericButNotRequired
      ]);
    } else {
      this.stateForm.get('executionTimeout').clearValidators();
      this.stateForm.patchValue({
        executionTimeout: null
      });
    }
    this.stateForm.get('executionTimeout').updateValueAndValidity();
  }

  setContinuousHumanInteractionValidation(hasContinuousHumanInteraction) {
    if (hasContinuousHumanInteraction.checked) {
      this.stateForm.get('nextHumanInteractionTimeOut').setValidators([
        Validators.min(1),
        Validators.max(2147482),
        CustomValidator.numeric
      ]);
    } else {
      this.stateForm.get('nextHumanInteractionTimeOut').clearValidators();
      this.stateForm.patchValue({
        nextHumanInteractionTimeOut: null,
        hasContinuousInteractionAlert: false
      });
    }
    this.stateForm.get('nextHumanInteractionTimeOut').updateValueAndValidity();
  }

  private getName(control: AbstractControl): string | null {
    const group = <FormGroup>control.parent;
    if (!group) {
      return null;
    }
    let name = '';
    Object.keys(group.controls).forEach(key => {
      const childControl = group.get(key);
      if (childControl !== control) {
        return;
      }
      name = key;
    });
    return name;
  }

}
